import { render, staticRenderFns } from "./GlobalConfigCardBulkOfferThreshold.vue?vue&type=template&id=5b755421"
import script from "./GlobalConfigCardBulkOfferThreshold.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigCardBulkOfferThreshold.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports